(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["petmagic-ai-chat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('petmagic-ai-chat')) {
    customElements.define('petmagic-ai-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const launcher = this.querySelector('.pm-ai-chat__launcher');
        const dialog = this.querySelector('dialog');
        const frame = this.querySelector('iframe');
        const loading = this.querySelector('.pm-ai-chat__loading');
        const closeButton = this.querySelector('.pm-ai-chat__close');
        const description = this.querySelector('#pm-ai-chat-description');
        const defaultDescription = description.textContent;
        let productContext = null;
        try { productContext = JSON.parse(this.dataset.productContext || 'null'); } catch {}
        const currentContext = () => {
          const page = new URL(window.location.href);
          const pageInfo = { type: this.dataset.pageType || 'unknown', title: document.querySelector('main h1')?.textContent?.trim() || this.dataset.pageTitle || '', url: page.origin + page.pathname };
          const context = { page: pageInfo, product: null };
          if (!productContext?.handle || !Array.isArray(productContext.variants)) return context;
          if (!page.pathname.endsWith(`/products/${productContext.handle}`)) return context;
          const field = document.querySelector('main form[action*="/cart/add"] [name="id"]:not([disabled])');
          const selected = String(field?.value || page.searchParams.get('variant') || productContext.selected || '');
          const variant = productContext.variants.find(item => String(item.id) === selected) || null;
          return { ...context, product: { handle: productContext.handle, title: productContext.title, url: productContext.url, variant } };
        };
        const showContext = context => {
          const product = context.product;
          description.textContent = product ? [product.title, product.variant?.title === 'Default Title' ? '' : product.variant?.title].filter(Boolean).join(' · ') : context.page?.title || defaultDescription;
        };
        let chatUrl;
        try { chatUrl = new URL(this.dataset.chatUrl); } catch { return; }
        if (chatUrl.protocol !== 'https:') return;
        const close = () => { if (dialog.open) dialog.close(); };
        launcher.hidden = false;
        launcher.addEventListener('click', () => {
          if (dialog.open) return;
          showContext(currentContext());
          dialog.showModal();
          launcher.setAttribute('aria-expanded', 'true');
          if (!frame.hasAttribute('src')) {
            frame.hidden = false;
            frame.src = chatUrl.href;
          }
          closeButton.focus();
        }, { signal });
        frame.addEventListener('load', () => { if (frame.hasAttribute('src')) loading.hidden = true; }, { signal });
        closeButton.addEventListener('click', close, { signal });
        dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, { signal });
        dialog.addEventListener('close', () => {
          launcher.setAttribute('aria-expanded', 'false');
          launcher.focus();
        }, { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
        }, { signal });
        document.addEventListener('keydown', event => {
          if (dialog.open && event.key === 'Escape') { event.preventDefault(); close(); }
        }, { signal });
        window.addEventListener('message', event => {
          if (event.origin !== chatUrl.origin || event.source !== frame.contentWindow) return;
          if (event.data?.type === 'petmagic:close-chat') close();
          if (event.data?.type === 'petmagic:request-context' && typeof event.data.requestId === 'string' && event.data.requestId.length <= 128) {
            const context = currentContext();
            showContext(context);
            frame.contentWindow.postMessage({ type: 'petmagic:page-context', requestId: event.data.requestId, context }, chatUrl.origin);
          }
        }, { signal });

      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["petmagic-rewards"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('pm-rewards');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const launcher = root.querySelector('.pm-rewards-launcher');
  const status = root.querySelector('[data-pm-status]');
  const summary = root.querySelector('[data-pm-summary]');
  const error = root.querySelector('[data-pm-error]');
  const retry = root.querySelector('[data-pm-retry]');
  let loading = false;
  const stickyBars = [...new Set(document.querySelectorAll('sticky-atc, .sticky-atc'))];
  let positionFrame = null;
  const scrollToTop = document.querySelector('.scroll-to-top-btn-bottom-right');
  const positionFloatingButtons = () => {
    positionFrame = null;
    let floor = window.innerWidth < 750 ? 12 : 20;
    for (const bar of stickyBars) {
      const height = bar.getBoundingClientRect().height;
      if (height > 0) floor = Math.max(floor, Math.ceil(height) + 12);
    }
    if (window.innerWidth < 750) {
      const filter = document.querySelector('.drawer__sticky-open');
      const bounds = filter?.getBoundingClientRect();
      if (bounds?.height > 0 && bounds.width > 0 && bounds.top < window.innerHeight && bounds.bottom > 0) {
        floor = Math.max(floor, Math.ceil(window.innerHeight - bounds.top) + 12);
      }
    }
    document.documentElement.style.setProperty('--pm-floating-floor', `${floor}px`);
    const bounds = launcher.getBoundingClientRect();
    if (scrollToTop && bounds.height > 0) {
      const floor = Math.ceil(window.innerHeight - bounds.top) + 12;
      scrollToTop.style.bottom = `max(var(--offset-y, 0px), ${floor}px)`;
    }
  };
  const queuePosition = () => {
    if (positionFrame == null) positionFrame = requestAnimationFrame(positionFloatingButtons);
  };
  positionFloatingButtons();
  if (typeof ResizeObserver !== 'undefined') {
    const positionObserver = new ResizeObserver(queuePosition);
    positionObserver.observe(launcher);
    for (const bar of stickyBars) positionObserver.observe(bar);
  }
  window.addEventListener('resize', queuePosition, { passive: true });
  window.addEventListener('scroll', queuePosition, { passive: true });

  function parseSummary(data) {
    const balance = data?.points_balance;
    const tier = data?.tier?.current?.name;
    if ((typeof balance !== 'number' && !(typeof balance === 'string' && /^\d+$/.test(balance))) || !Number.isSafeInteger(Number(balance)) || Number(balance) < 0 || typeof tier !== 'string' || !tier.trim()) throw new Error('Invalid summary');
    return { balance: Number(balance), tier: tier.trim() };
  }

  async function refresh() {
    if (!root.dataset.customer || loading) return;
    loading = true;
    status.hidden = false;
    summary.hidden = error.hidden = retry.hidden = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const base = new URL(root.dataset.api);
      if (base.protocol !== 'https:') throw new Error('Invalid API');
      const response = await fetch(new URL('/api/loyalty/summary', base), {
        headers: { 'X-Shopify-Shop-Domain': root.dataset.shop, 'X-Shopify-Customer-Id': root.dataset.customer },
        signal: controller.signal,
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Summary unavailable');
      const data = parseSummary(await response.json());
      root.querySelector('[data-pm-balance]').textContent = data.balance.toLocaleString('ja-JP');
      root.querySelector('[data-pm-tier]').textContent = data.tier;
      summary.hidden = false;
    } catch (_) {
      error.hidden = retry.hidden = false;
    } finally {
      clearTimeout(timeout);
      status.hidden = true;
      loading = false;
    }
  }

  launcher.addEventListener('click', () => {
    dialog.showModal();
    launcher.setAttribute('aria-expanded', 'true');
    refresh();
  });
  root.querySelector('.pm-rewards-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus({preventScroll: true});
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('a')) { dialog.close(); return; }
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  retry?.addEventListener('click', refresh);
})();
  } catch(e) { console.error(e); }
})();

})();
